import * as React from "react";
import type { SVGProps } from "react";
const SvgIconElevator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.73 1.61c-1.1.14-1.98 1.02-2.12 2.15-.04.3-.04 16.18 0 16.48q.11.9.76 1.5.58.55 1.4.65c.28.04 16.18.04 16.46 0q.43-.05.8-.24c.76-.37 1.26-1.07 1.36-1.92.04-.28.04-16.18 0-16.46-.14-1.15-1-2.02-2.15-2.16-.26-.03-16.25-.03-16.5 0m.1 1.73c-.21.06-.44.3-.5.5-.01.06-.02 2.75-.01 8.21v8.12l.07.13q.12.2.34.32c.1.05.12.06.97.06l.87.01v-4.41c0-2.97 0-4.46.02-4.57.11-.66.68-1.23 1.35-1.34.21-.04 9.9-.04 10.12 0 .67.1 1.24.68 1.35 1.34q.02.13.02 4.57v4.41h.87l.87-.01.13-.08q.2-.1.32-.33l.06-.1V3.83l-.06-.1q-.11-.22-.32-.34l-.13-.07h-8.13c-4.84 0-8.17 0-8.22.02M8.16 4.8 8 4.88c-.11.06-2.16 2.1-2.28 2.28-.16.24-.18.59-.05.86.07.13.26.3.4.38.13.05.17.06.37.06.37 0 .38 0 1.26-.87l.73-.74.74.74c.87.86.88.87 1.26.87.2 0 .24 0 .36-.07q.3-.17.43-.46c.07-.2.06-.5-.02-.67-.05-.1-.3-.36-1.13-1.2-.59-.59-1.13-1.1-1.2-1.15-.06-.04-.16-.09-.21-.1-.13-.04-.35-.04-.48 0m5.17 0c-.26.08-.5.32-.56.56q-.04.14-.03.31c.01.33 0 .31 1.26 1.57 1.07 1.06 1.13 1.12 1.27 1.17.11.04.18.05.33.05.36-.02.34 0 1.58-1.24.7-.7 1.11-1.13 1.14-1.2.03-.05.06-.17.08-.25.1-.5-.27-.96-.77-1q-.28-.03-.52.13c-.06.04-.43.4-.82.79l-.71.7-.75-.74c-.64-.63-.76-.75-.89-.8-.17-.08-.44-.1-.6-.05M7.3 16.38v4.3h3.84v-8.6H7.3zm5.56 0v4.3h3.84v-8.6h-3.84z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconElevator;
